export default {
  path: 'view-project',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'View Project',
      component: () => import('@/views/menus/viewProject/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
